/** App table values referenced within FE. */
const SERVICE_LOOKUP_BASE_URL = '/api/service_lookup'

export const LOOKUP_URLS = Object.freeze({
  BEHAVIOR: `${SERVICE_LOOKUP_BASE_URL}/pt_session_behaviors`,
  OBJECTIVE: `${SERVICE_LOOKUP_BASE_URL}/pt_session_objectives`,
  PROGRESS: `${SERVICE_LOOKUP_BASE_URL}/pt_session_progress`,
  IMPLEMENTATION: `${SERVICE_LOOKUP_BASE_URL}/pt_session_objective_implementation`,
  ASSIST_TYPE: `${SERVICE_LOOKUP_BASE_URL}/pt_session_assist_type`
});

export const CODES = Object.freeze({
  OTHER: 'OTHER'
});

export const GROUP_TYPE = Object.freeze({
  GROUP: 'GROUP'
});



// WEBPACK FOOTER //
// ./src/constants/service-log.js